import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../component/popup/modal-layout";
import XCloseIcon from "../../../component/icons/x-close";
import Style from "./style.module.css";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
} from "../../../component/form/form-layout";
import { useApiCall } from "../../../component/custom-hooks/api-call";

const AddSales = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  qaFormData,
}) => {
  const yesNoOptions = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];

  console.log(qaFormData);

  const apiCall = useApiCall();

  const validationSchema = yup.object({
    sale_authorized: yup.number().required("Required"),
    merchant_description: yup.number().required("Required"),
    wrong_sale: yup.number().required("Required"),
    comments_by_qa: yup.string().required("Required"),
    wrong_sale_comment: yup.string().when("wrong_sale", {
      is: 1,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
  });

  // ----------------------------
  // Formik with dynamic initial values
  // ----------------------------
  const formik = useFormik({
    enableReinitialize: true, // ✅ important for pre-filled data
    initialValues: {
      transaction_id: qaFormData?.transaction_id || "",
      sale_authorized: qaFormData?.sale_authorized ?? null,
      merchant_description: qaFormData?.merchant_description ?? null,
      wrong_sale: qaFormData?.wrong_sale ?? 0,
      comments_by_qa: qaFormData?.comments_by_qa || "",
      wrong_sale_comment: qaFormData?.wrong_sale_comment || "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        const payload = {
          transaction_id: values.transaction_id,
          sale_authorized: values.sale_authorized,
          merchant_description: values.merchant_description,
          wrong_sale: values.wrong_sale,
          comments_by_qa: values.comments_by_qa,
          wrong_sale_comment: values.wrong_sale_comment,
        };

        // API call
        const res = await apiCall({
          method: "post",
          url: "wrong-sale", // ✅ API endpoint
          data: payload,
        });

        formik.resetForm();
        onSubmit(res?.message || "Sales Added Successfully", "add_sales");
      } catch (error) {
        console.error(error);
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.message ||
            "Something went wrong"
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        {/* HEADER */}
        <div
          className={`${Style.modal_header} ${Style.addMeModal_head} flex justify-between items-center`}
        >
          <h4>Authorization</h4>
          <div
            onClick={onClose}
            className={`${Style.close_btn} cursor-pointer`}
          >
            <XCloseIcon />
          </div>
        </div>

        {/* BODY */}
        <div className={Style.addMeModal_body}>
          <div className={Style.dcmb__card}>
            <div className={Style.dcmb__cardBody}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  {/* ROW 1 — 2 DROPDOWNS */}
                  <div className="flex w-full">
                    <FeildWraper width="50%">
                      <FormLabel required>Sale Authorized</FormLabel>
                      <select
                        name="sale_authorized"
                        value={formik.values.sale_authorized}
                        onChange={(e) =>
                          formik.setFieldValue(
                            "sale_authorized",
                            Number(e.target.value)
                          )
                        }
                      >
                        <option value="">Select</option>
                        {yesNoOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                      {formik.touched.sale_authorized &&
                        formik.errors.sale_authorized && (
                          <FeildError>
                            {formik.errors.sale_authorized}
                          </FeildError>
                        )}
                    </FeildWraper>

                    <FeildWraper width="50%">
                      <FormLabel required>Merchant Description</FormLabel>
                      <select
                        name="merchant_description"
                        value={formik.values.merchant_description}
                        onChange={(e) =>
                          formik.setFieldValue(
                            "merchant_description",
                            Number(e.target.value)
                          )
                        }
                      >
                        <option value="">Select</option>
                        {yesNoOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                      {formik.touched.merchant_description &&
                        formik.errors.merchant_description && (
                          <FeildError>
                            {formik.errors.merchant_description}
                          </FeildError>
                        )}
                    </FeildWraper>
                  </div>

                  {/* ROW 2 — WRONG SALE RADIO */}
                  <div className="flex px-3 gap-2 mt-3 mb-3">
                    <div>
                      <p className="!text-sm !font-medium !leading-5 !text-[#1E2E54]">
                        Wrong Sale
                      </p>
                    </div>
                    <div className="flex gap-5 items-center text-sm">
                      <label className="flex gap-1 font-sm font-medium leading-5 !text-[#1E2E54]">
                        <input
                          type="radio"
                          name="wrong_sale"
                          value={1}
                          checked={formik.values.wrong_sale == 1}
                          onChange={() => formik.setFieldValue("wrong_sale", 1)}
                        />
                        Yes
                      </label>
                      <label className="flex gap-1 font-sm font-medium leading-5 !text-[#1E2E54]">
                        <input
                          type="radio"
                          name="wrong_sale"
                          value={0}
                          checked={formik.values.wrong_sale == 0}
                          onChange={() => formik.setFieldValue("wrong_sale", 0)}
                        />
                        No
                      </label>
                      {formik.touched.wrong_sale &&
                        formik.errors.wrong_sale && (
                          <FeildError>{formik.errors.wrong_sale}</FeildError>
                        )}
                    </div>
                  </div>

                  {/* ROW 3 — COMMENT BOXES */}
                  <div className="flex w-full">
                    <FeildWraper width="50%">
                      <FormLabel required={formik.values.wrong_sale == 1}>
                        Wrong Sale Comment
                      </FormLabel>
                      <textarea
                        name="wrong_sale_comment"
                        value={formik.values.wrong_sale_comment}
                        onChange={formik.handleChange}
                        placeholder="Enter wrong sale details..."
                      />
                      {formik.touched.wrong_sale_comment &&
                        formik.errors.wrong_sale_comment && (
                          <FeildError>
                            {formik.errors.wrong_sale_comment}
                          </FeildError>
                        )}
                    </FeildWraper>

                    <FeildWraper width="50%">
                      <FormLabel required>Comments by QA</FormLabel>
                      <textarea
                        name="comments_by_qa"
                        value={formik.values.comments_by_qa}
                        onChange={formik.handleChange}
                        placeholder="Write QA comments..."
                      />
                      {formik.touched.comments_by_qa &&
                        formik.errors.comments_by_qa && (
                          <FeildError>
                            {formik.errors.comments_by_qa}
                          </FeildError>
                        )}
                    </FeildWraper>
                  </div>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className={Style.dcmb__cardFoot}>
          <button type="reset" className={Style.dcmb__cancel} onClick={onClose}>
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            Submit
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddSales;
